export const inputTypes = {
  TEXT: "text",
  PHONE: "phone",
  CHECKBOX: "checkbox",
  SELECT: "select",
  SELECTSTYLE2: "selectstyle2",
  BUTTONPRIMARY: "buttonprimary",
  CREATABLESELECT: "creatableselect",
  MULTISELECT: "multiselect",
  MULTICREATABLESELECT: "multicreatableselect",
  PRICE: "price",
  NUMBER: "number",
  DATE: "date",
  TIME: "time",
  YEAR: "year",
  TEXTAREA: "textarea",
  MONTH: "month"
};
